import axios from 'axios';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import React, { useEffect, useState } from 'react';
import { BASE_URL } from './BaseUrl';
import InnerHeader from './InnerHeader';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { getRoleData } from "../Store/Role/role-action";
import Cookies from "js-cookie";
import { Autocomplete, TextField } from '@mui/material';
import { pdf } from "@react-pdf/renderer";
import CollegeFollowUp from './Document/CollegeFollowUp';


const CollogeFollowUp = () => {

    const [showListing, setShowListing] = useState(false);
    const [college, setCollege] = useState([])
    const [city, setCity] = useState([])
    const [error, setError] = useState({})

    const [value, setValue] = useState({
        college: "",
        city: "",
        purpose: "",
        fromdate: "",
        todate: "",
    })

    const getCollegeData = () => {

        const data = {
            tablename: "awt_college",
            columnname: "id,college_name"
        }

        axios.post(`${BASE_URL}/get_data`, data)
            .then((res) => {
                console.log(res.data)
                setCollege(res.data)
            })
            .catch((err) => {
                console.log(err)
            })

    }
    const getCityData = () => {
        axios.post(`${BASE_URL}/get_collegecity`)
            .then((res) => {
                console.log(res.data);
                setCity(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };


    useEffect(() => {
        getCollegeData()
        getCityData()
    }, [])

    const [pdfdata, setpdfData] = useState([]);

    async function getDetails() {
        const param = {
            college: value.college,
            city: value.city,
            purpose: value.purpose,
            fromdate: value.fromdate,
            todate: value.todate,
        };

        axios.post(`${BASE_URL}/getcollegefollowereport`, param).then((res) => {
            setpdfData(res.data);
            collegefollowsreport(res.data)
        });
    }

    async function getCollegeList(e) {
        e.preventDefault();

        let newErrors = {};

        if (!value.fromdate) newErrors.fromdate = "From Date is required";
        if (!value.todate) newErrors.todate = "To Date is required";
        if (!value.college) newErrors.college = "College is required";
        if (!value.city) newErrors.city = "City is required";
        if (!value.purpose) newErrors.purpose = "Purpose is required";

        setError(newErrors);

        if (Object.keys(newErrors).length > 0) return; // Stop if errors

        const param = {
            college: value.college,
            city: value.city,
            purpose: value.purpose,
            fromdate: value.fromdate,
            todate: value.todate,
        };

        axios.post(`${BASE_URL}/getcollegefollowereport`, param).then((res) => {
            setpdfData(res.data);
            setShowListing(true);
        });
    }


    const collegefollowsreport = async (data) => {
        const blob = await pdf(<CollegeFollowUp data={data} />).toBlob();
        const url = URL.createObjectURL(blob);
        window.open(url);
        URL.revokeObjectURL(url);
    };


    const onhandleChange = (e) => {
        setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }


    const roledata = {
        role: Cookies.get(`role`),
        pageid: 52,
    };

    const dispatch = useDispatch();
    const roleaccess = useSelector((state) => state.roleAssign?.roleAssign[0]?.accessid);

    useEffect(() => {
        dispatch(getRoleData(roledata));
    }, []);

    const exportToExcel = () => {
        let newErrors = {};

        if (!value.fromdate) newErrors.fromdate = "From Date is required";
        if (!value.todate) newErrors.todate = "To Date is required";
        if (!value.college) newErrors.college = "College is required";
        if (!value.city) newErrors.city = "City is required";
        if (!value.purpose) newErrors.purpose = "Purpose is required";

        setError(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        if (pdfdata.length === 0) {
            alert("No data to export");
            return;
        }

        const fromDate = value.fromdate ? new Date(value.fromdate).toLocaleDateString("en-GB") : "";
        const toDate = value.todate ? new Date(value.todate).toLocaleDateString("en-GB") : "";

        // Title row
        const title = [[`College Follow Up Report from: ${fromDate} To: ${toDate}`]];

        // Header row
        const headers = [[
            "Id",
            "College Name",
            "Contact Name",
            "Phone",
            "Email",
            "Discipline",
            "Designation",
            "Purpose",
            "Remark",
            "Tdate",
            "DirectLine",
            "City"
        ]];

        // Data rows
        const rows = pdfdata.map((item, index) => [
            index + 1,
            item.college_name || "",
            item.CName || "",
            item.Phone || "",
            item.Email || "",
            item.Discipline || "",
            item.Designation || "",
            item.Purpose || "",
            item.Remark || "",
            item.Tdate || "",
            item.DirectLine || "",
            item.city || ""
        ]);

        const sheetData = [...title, [], ...headers, ...rows];

        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

        // Merge title row across all columns
        worksheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 11 } }, // merge A1 to L1
        ];

        worksheet["!cols"] = [
            { wch: 5 },   // Id
            { wch: 25 },  // College Name
            { wch: 25 },  // Contact Name
            { wch: 15 },  // Phone
            { wch: 30 },  // Email
            { wch: 20 },  // Discipline
            { wch: 20 },  // Designation
            { wch: 20 },  // Purpose
            { wch: 40 },  // Remark
            { wch: 15 },  // Tdate
            { wch: 15 },  // DirectLine
            { wch: 15 },  // City
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "CollegeFollowUp");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `College_FollowUp_Report_${Date.now()}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };






    const columns = [
        {
            field: 'index',
            headerName: 'Id',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,

        },
        { field: 'college_name', headerName: 'College Name', flex: 2 },
        { field: 'CName', headerName: 'Contact Name', flex: 2 },
        { field: 'Phone', headerName: 'Phone', flex: 2 },
        { field: 'Email', headerName: 'Email', flex: 2 },
        { field: 'Discipline', headerName: 'Discipline', flex: 2 },
        { field: 'Designation', headerName: 'Designation', flex: 2 },
        { field: 'Purpose', headerName: 'Purpose', flex: 2 },
        { field: 'Remark', headerName: 'Remark', flex: 2 },
       {
    field: 'Tdate',
    headerName: 'Tdate',
    flex: 2,
    renderCell: (params) => {
        if (!params.value) return ""; // Handle empty values

        // If already in DD-MM-YYYY format
        const ddmmyyyyRegex = /^\d{2}-\d{2}-\d{4}$/;
        if (ddmmyyyyRegex.test(params.value)) {
            return params.value;
        }

        // If API returns yyyymmdd format
        if (/^\d{8}$/.test(params.value)) {
            const year = params.value.substring(0, 4);
            const month = params.value.substring(4, 6);
            const day = params.value.substring(6, 8);
            return `${day}-${month}-${year}`;
        }

        // Try parsing yyyy-mm-dd or other valid date strings
        const date = new Date(params.value);
        if (isNaN(date.getTime())) return ""; // Invalid date fallback

        return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
    }
},

        { field: 'DirectLine', headerName: 'DirectLine', flex: 2 },
        { field: 'city', headerName: 'City', flex: 2 },

    ];
    const rowsWithIds = pdfdata.map((row, index) => ({ id: index + 1, index: index + 1, ...row }));


    return (

        <div class="container-fluid page-body-wrapper">
            <InnerHeader />
            <div class="main-panel">
                <div class="content-wrapper">
                    <div class="row">
                        <div class="col-lg-12 grid-margin stretch-card">
                            <div class="card">
                                <div class="card-body">
                                    <h4 class="card-title">College Follow Up Report</h4>
                                    <hr></hr>
                                    <form class="forms-sample py-3" >
                                        <div class='row'>

                                            <div class="form-group col-lg-2" style={{ display: 'flex', flexDirection: 'column' }}>
                                                <label for="exampleInputUsername1">From Date<span className='text-danger'>*</span></label>
                                                <DatePicker
                                                    selected={value.fromdate ? new Date(value.fromdate) : null}
                                                    onChange={(date) => onhandleChange({ target: { name: "fromdate", value: date } })}
                                                    className="form-control"
                                                    id="exampleInputUsername1"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Select a date"
                                                />
                                                {<span className="text-danger"> {error.fromdate} </span>}
                                            </div>

                                            <div class="form-group col-lg-2" style={{ display: 'flex', flexDirection: 'column' }}>
                                                <label for="exampleInputUsername1">To Date <span className='text-danger'>*</span></label>
                                                <DatePicker
                                                    selected={value.todate ? new Date(value.todate) : null}
                                                    onChange={(date) => onhandleChange({ target: { name: "todate", value: date } })}
                                                    className="form-control"
                                                    id="exampleInputUsername1"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Select a date"
                                                />
                                                {<span className="text-danger"> {error.todate} </span>}
                                            </div>


                                            <div class="form-group col-lg-4">
                                                <label for="exampleFormControlSelect1">Select College<span className='text-danger'>*</span> </label>
                                                <Autocomplete
                                                    disablePortal
                                                    options={college}
                                                    getOptionLabel={(option) => option.college_name || ""}
                                                    value={college.find(item => item.id === value.college) || null}
                                                    onChange={(event, newValue) => {
                                                        onhandleChange({
                                                            target: {
                                                                name: 'college',
                                                                value: newValue ? newValue.id : ""
                                                            }
                                                        });
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Select College" size="small" />
                                                    )}
                                                />
                                                {<span className="text-danger"> {error.college} </span>}
                                            </div>

                                            <div class="form-group col-lg-2">
                                                <label for="exampleFormControlSelect1">Select City<span className='text-danger'>*</span> </label>
                                                <select class="form-control" id="exampleFormControlSelect1"
                                                    value={value.city} name='city' onChange={onhandleChange}>
                                                    <option value="">Select City</option>
                                                    {city.map((item) => {
                                                        return (
                                                            <option value={item.city}>{item.city}</option>

                                                        )
                                                    })}
                                                </select>
                                                {error.city && <span className="text-danger">{error.city}</span>}
                                            </div>

                                            <div class="form-group col-lg-2">
                                                <label for="exampleFormControlSelect1">Select Purpose <span className='text-danger'>*</span> </label>
                                                <select class="form-control form-control-lg" id="exampleFormControlSelect1" value={value.purpose} onChange={onhandleChange} name='purpose'>

                                                    <option value="">Select Purpose</option>
                                                    <option value="Adertisement">Adertisement</option>
                                                    <option value="Advertisement">Advertisement</option>
                                                    <option value="Meeting">Meeting</option>
                                                    <option value="Others">Others</option>
                                                    <option value="Placemnent">Placemnent</option>
                                                    <option value="Proposal">Proposal</option>
                                                    <option value="Seminar">Seminar</option>
                                                    <option value="Sponsership-stall">Sponsership-stall</option>
                                                    <option value="Training">Training</option>

                                                </select>
                                                {error.purpose && <span className="text-danger">{error.purpose}</span>}
                                            </div>



                                        </div>
                                        <button type="submit" class="btn btn-primary mr-2" onClick={getCollegeList}>Go</button>
                                        <button type="button" class="btn btn-primary mr-2" onClick={exportToExcel}>Excel</button>


                                        <button
                                            type="button"
                                            onClick={getDetails}
                                            class="btn btn-primary mr-2"
                                            disabled={
                                                !value.college ||
                                                value.college === "Select College" ||
                                                !value.city ||
                                                value.city === "Select City" ||
                                                !value.purpose ||
                                                value.purpose === "Select Purpose" ||
                                                !value.fromdate ||
                                                !value.todate
                                            }>
                                            Print
                                        </button>
                                        <button type='button' onClick={() => {
                                            window.location.reload()
                                        }} class="btn btn-primary mr-2">Cancel</button>






                                    </form>

                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="card">
                                <div class="card-body">
                                    <div className='d-flex justify-content-between'>
                                        <div>
                                            <h4 class="card-title">Annual Batch Plan Details</h4>
                                        </div>
                                    </div>
                                    {showListing && (
                                        <DataGrid
                                            rows={rowsWithIds}
                                            columns={columns}
                                            disableColumnFilter
                                            disableColumnSelector
                                            disableDensitySelector
                                            rowHeight={35}
                                            // getRowId={(row) => row.id}
                                            initialState={{
                                                pagination: {
                                                    paginationModel: { pageSize: 10, page: 0 },
                                                },
                                            }}
                                            slots={{ toolbar: GridToolbar }}
                                            slotProps={{
                                                toolbar: {
                                                    showQuickFilter: true,
                                                },
                                            }}
                                        />
                                    )}






                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div >

    )
}

export default CollogeFollowUp
